"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapValues = void 0;
function mapValues(object, fn) {
    var result = {};
    Object.keys(object).forEach(function (key) {
        var value = fn(object[key]);
        if (value !== undefined) {
            result[key] = value;
        }
    });
    return result;
}
exports.mapValues = mapValues;
//# sourceMappingURL=mapValues.js.map